import React from 'react';
import { FullSizeColumn } from '../../FlexBox';
import EntryComponent from '../EntryComponent';
import EmptyInfiniteListComponent from '../EmptyInfiniteListComponent';

const renderEntryComponent = (data) => (
  <EntryComponent key={`${data?.data?.id}`} {...data} />
);

const EntryListWrapper = function EntryListWrapper({
  customStatusChipCallback = null,
  rowSxCallback = null,
  disableClickRow = false,
  columns,
  ObserverWrapper,
  wavePeriod,
  updateItem,
  currentSection,
  customEntryFunction,
  singlePageList,
  customClick,
}) {
  const renderItem = (item) =>
    customEntryFunction
      ? customEntryFunction(item)
      : renderEntryComponent({
          data: item,
          updateItem,
          wavePeriod,
          columns,
          currentSection,
          disableClickRow,
          rowSxCallback,
          customStatusChipCallback,
          customClick,
        });

  return (
    <FullSizeColumn overflow="auto">
      {singlePageList && singlePageList.length === 0 ? (
        <EmptyInfiniteListComponent />
      ) : null}
      {singlePageList ? (
        singlePageList.map((item) => renderItem(item))
      ) : (
        <ObserverWrapper Component={renderItem} />
      )}
    </FullSizeColumn>
  );
};

export default EntryListWrapper;
